__turbopack_context__.v({
  "unstyledLink": "styles-module__BewhRW__unstyledLink",
});
